<script lang="ts">
  import { mloc } from "module/utils";
  import { getSetting, setSetting } from "module/settings";

  import {
    filterStore,
    toggleFilter,
    updateFilter,
  } from "module/store/FilterStore";
  import { FilterType } from "module/store/Filters";

  import SearchApp from "app/search/SearchApp.svelte";
  import FilterEditor from "./FilterEditor.svelte";
  import FilterList from "./FilterList.svelte";
  import FilterMetaHeader from "./FilterMetaHeader.svelte";
  import { deleteDialog, newDialog } from "./dialogs";
  import NiceButton from "../NiceButton.svelte";

  let { active = false } = $props();
  let selectedId: string | undefined = $state();

  let filter = $derived(selectedId && $filterStore[selectedId]);

  function selectFilter(event: CustomEvent) {
    const { id } = event.detail;
    selectedId = id;
  }

  function clone(evt: CustomEvent<string>) {
    newDialog(
      $filterStore[evt.detail],
      (newId) => (selectedId = newId),
      FilterType.Client
    );
  }

  function toggle(evt: CustomEvent<string>) {
    toggleFilter(evt.detail);
  }

  function deleteId(evt: CustomEvent<string>) {
    deleteDialog($filterStore[evt.detail], () => {
      if (evt.detail === selectedId) selectedId = undefined;
    });
  }

  function onConfigChange(evt: CustomEvent) {
    if (!filter || filter.type === FilterType.Default) return;

    filter.filterConfig = evt.detail;
    updateFilter(filter);
  }

  function newFilter() {
    newDialog(
      undefined,
      (newId: string) => {
        selectedId = newId;
      },
      FilterType.Client
    );
  }

  function changeSubTitle(evt: CustomEvent) {
    if (filter && filter.type !== FilterType.Default)
      updateFilter({ ...filter, subTitle: evt.detail });
  }

  function changeTag(evt: CustomEvent) {
    if (filter && filter.type !== FilterType.Default)
      updateFilter({ ...filter, tag: evt.detail });
  }

  function changeRole(evt: CustomEvent) {
    if (filter && filter.type !== FilterType.Default)
      updateFilter({ ...filter, role: evt.detail });
  }
</script>

<div class:hidden={!active} class="filters-tab" role="tabpanel">
  {#if filter}
    <header>
      <h3 on:click={() => (selectedId = undefined)}>
        <i class="fas fa-chevron-left"></i>
        @{filter?.tag}
      </h3>
      <FilterMetaHeader
        {filter}
        on:clone={clone}
        on:toggle={toggle}
        on:delete={deleteId}
        on:subTitleChange={changeSubTitle}
        on:tagChange={changeTag}
        on:roleChange={changeRole}
      />
    </header>
    <section>
      <main>
        <FilterEditor
          filterConfig={filter.filterConfig}
          on:change={onConfigChange}
        />
      </main>
      <aside class="search-app-container">
        <span class="try-me">
          {mloc("FilterEditorTryMe")}
          <i class="fas fa-hand-point-down"></i>
        </span>
        <SearchApp {filter} embedded />
      </aside>
    </section>
  {/if}

  <div class="header notes" class:hidden={selectedId}>
    {mloc("FilterListHeader")}
    <p>{mloc("FilterListClientNotes")}</p>
  </div>

  <FilterList
    selected={selectedId}
    types={[FilterType.Client]}
    on:selectFilter={selectFilter}
    on:clone={clone}
    on:toggle={toggle}
    on:delete={deleteId}
  />
  <menu class:hidden={selectedId}>
    <NiceButton round on:click={newFilter}>
      <i class="fas fa-plus"></i>
      {mloc("FilterListCreateClientFilter")}
    </NiceButton>
  </menu>
</div>

<style>
  .header {
    margin: 0;
    padding: 0.6em;
    border-bottom: 2px solid #444;
    flex: auto;
  }

  .filters-tab {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .hidden {
    display: none;
  }
  header {
    width: 100%;
    padding: 0.4em 0.7em;
    border-bottom: 2px solid #333;
    background: rgba(0, 0, 0, 0.1);
  }
  h3 {
    border: none;
    margin: 0;
    display: flex;
    align-items: center;
    padding: 0.1em 0;
    color: var(--color-text-primary);
    text-shadow: none;
    width: fit-content;
  }
  section {
    width: 100%;
    display: flex;
    overflow: auto;
    flex-grow: 1;
  }
  aside {
    padding: 0.4em;
    width: 350px;
    border-left: 1px solid rgba(0, 0, 0, 0.3);
    overflow: auto;
    flex-shrink: 0;
  }
  aside :global(.search-app) {
    border: 1px solid #493a50;
    border-radius: 6px;
  }
  main {
    flex-grow: 1;
    padding: 0.4em;
    max-width: calc(100% - 200px);
    display: flex;
    flex-direction: column;
  }

  .search-app-container {
    display: flex;
    flex-direction: column;
    justify-content: end;
  }

  .try-me {
    text-align: center;
    opacity: 0.9;
    padding: 0.5em;
  }
  menu {
    display: flex;
    margin: 0;
    padding: 0.2em 1em;
  }

  .fa-chevron-left {
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 25px;
  }
</style>
